import script from "./LessonStory.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonStory.vue?vue&type=script&setup=true&lang=js"

import "./LessonStory.vue?vue&type=style&index=0&id=5947a202&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5947a202"]])

export default __exports__